import { ToastContainerProps } from "react-toastify"

export const toastDefaultProps: ToastContainerProps = {
  autoClose: 2000,
  position: "bottom-right"
}
